import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { getAvailablePeriod, getCompanyInfo, getReport } from "modules/HRAccount/api"
import { DefaultPeriod, FixedPeriod } from "modules/HRAccount/PeriodsDropdown/PeriodsDropdown"

export function useGetCompanyInfo() {
    return useQuery(["company-info"], getCompanyInfo)
}

export function useGetPeriod() {
    return useQuery(["available-period"], getAvailablePeriod, {
        select: (availablePeriod) => ({
            startDate: availablePeriod.start_date
                ? new Date(availablePeriod.start_date * 1000)
                : new Date(),
            hasData: availablePeriod.start_date !== null,
        }),
    })
}

export function useGetReport(period: DefaultPeriod | FixedPeriod) {
    return useQuery({
        queryKey: ["statistic", period.label],
        queryFn: () => getReport(period),
        onError: (err: AxiosError) => err,
    })
}
